import { type ReactNode, createContext, useState } from 'react';

import {
  createAppStore,
  getDefaultServerSideState
} from 'src/store/CreateStore';
import { AppState } from 'src/store/interface';

export const AppStoreContext = createContext(
  createAppStore(getDefaultServerSideState())
);

export interface AppStoreProviderProps {
  children: ReactNode;
  value: AppState;
}

export const AppStoreProvider = ({
  children,
  value
}: AppStoreProviderProps) => {
  const [store] = useState(() => createAppStore(value));

  return (
    <AppStoreContext.Provider value={store}>
      {children}
    </AppStoreContext.Provider>
  );
};
